module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "id-refresh": "btn-refresh-rol"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['roles:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'rol', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['roles:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'rol')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.descripcion))])]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['roles:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('rol.add')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-icon', [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('rol.crud.editRol') : _vm.$t('rol.crud.addRol')) + "\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nombre",
      "label": _vm.$t('rol.crud.name'),
      "id": "nombre",
      "rules": _vm.$validate(['required']),
      "required": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.$set(_vm.form, "nombre", $$v)
      },
      expression: "form.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "descripcion",
      "label": _vm.$t('rol.crud.description'),
      "id": "descripcion",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.form, "descripcion", $$v)
      },
      expression: "form.descripcion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal');
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')) + "\n              ")], 1)], 1)], 1)], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db7ae3fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/preferencias/Rol.vue
// module id = 537
// module chunks = 2